import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0f5e93a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]

import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '@/components/tir-pm-list/models';
import { computed, PropType, ref } from 'vue';
import TaskCardItemWrapper from './task-card-item-wrapper.vue';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-estimate-time',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
},
  setup(__props) {

const props = __props;



/**Оценка времени */
const estimateTime = computed(() => {
  if (props.task.EstimateTime) {
    return props.task.EstimateTime?.toFixed(2).replace('.', 'ч ') + 'м';
  } else {
    return '-';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TaskCardItemWrapper, { element: __props.element }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "work-time-empty",
        textContent: _toDisplayString(estimateTime.value)
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["element"]))
}
}

})